import PropTypes from 'prop-types';
import { type FC, type ReactNode } from 'react';
import type React from 'react';
import { useIntl } from 'react-intl';

import { useFeatureSwitches } from '@xing-com/crate-hooks-use-feature-switches';
import { useSetIsBottomBarEnabled } from '@xing-com/hub';
import { TopBar } from '@xing-com/top-bar';

import { useDeviceInfo } from '../../hooks/use-device-info/use-device-info';
import { LoggedInContent } from './logged-in-content';

type LoggedInPageProps = {
  children?: ReactNode;
};
export const LoggedInPage: FC<LoggedInPageProps> = ({ children }) => {
  const featureSwitches = useFeatureSwitches();
  const { isWebview } = useDeviceInfo();
  const { formatMessage } = useIntl();
  const setIsButtonBarEnabled = useSetIsBottomBarEnabled();

  setIsButtonBarEnabled(!isWebview);

  const isArmstrong =
    featureSwitches?.filter((x) => x === 'armstrong_v1').length > 0;

  if (isWebview) {
    return <LoggedInContent>{children}</LoggedInContent>;
  }

  return (
    <>
      {isArmstrong && (
        <TopBar
          title={formatMessage({ id: 'SE_LABEL_COMPANIES' })}
          type="subheader"
        />
      )}
      <LoggedInContent>{children}</LoggedInContent>
    </>
  );
};

LoggedInPage.propTypes = {
  children: PropTypes.node.isRequired,
} as React.WeakValidationMap<LoggedInPageProps>;
